var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-rectangle",style:(_vm.styles)},[_c('apexcharts',{staticClass:"rectangle-chart",attrs:{"series":_vm.data,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }